/**
 * Canonical tab list for the Candidate Page (30j-1 → 30j-6).
 *
 * Lives here (not in `CandidatePageTabs.tsx`) so a non-component module
 * carries the constants and React Fast-Refresh stays clean on the tabs
 * component. Architect §1.3 / HoD §2.6.
 */
export type TabKey = "resume" | "eval" | "prep" | "analysis" | "notes";

export const TABS: ReadonlyArray<{ key: TabKey; label: string }> = [
  { key: "resume", label: "Resume" },
  { key: "eval", label: "AI Evaluation" },
  { key: "prep", label: "Interview Prep" },
  { key: "analysis", label: "Interview Analysis" },
  { key: "notes", label: "Notes" },
];

// Internal — kept module-private. Public consumers use `resolveActiveTab`
// or iterate `TABS`.
const TAB_KEY_SET: ReadonlySet<string> = new Set(TABS.map((t) => t.key));

/**
 * Validate-and-default helper for the `?tab=` query param. Unknown values
 * silently fall back to ``resume`` (CTO-OQ-3 resolution: predictability
 * over data-presence heuristics; HoD §2.7 + Architect §2). NO redirect,
 * NO URL rewrite — degrades gracefully.
 */
export function resolveActiveTab(raw: string | null | undefined): TabKey {
  if (raw && TAB_KEY_SET.has(raw)) return raw as TabKey;
  return "resume";
}
